<!-- 商品列表 -->

<template>
  <div class='content'>
    <div class="container in_ctn_box">
      <div class="mainbaoxie">
        <router-link to="/home">Homepage</router-link>
        <i class="el-icon-arrow-right" style="margin: 0 4px;"></i>
        <span>Product List</span>
      </div>

      <div class="good_out_box">
        <div class="nav_box">
          <div class="tt">Product categories</div>
          <div v-for="(item, index) in brandList" :key="index" :class="{ cur: item.brandId == activeBrandId }"
            class="line_box" @click="changeActiveBrand(item)" style="cursor: pointer;">
            <img v-if="item.brandId == activeBrandId" src="@/assets/images1/41.png" alt="" class="icon">
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div style="flex: 1;">
          <good-list :goodList="list" :columnNum="4" listCss="width:auto;" />

          <el-empty v-if="!listLoading && !list.length" description=" "></el-empty>
          <!-- 分页组件 -->
          <div style="margin-top: 32px;display: flex;justify-content: flex-end;">
            <CPagination v-if="listtotal && listpage > 1" layout="total,prev, pager, next" :current-page="listpage"
              :total="listtotalPage" :total-page="listtotalPage" @pageChange="listPageChange" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import GoodList from '../../../components/GoodList/GoodList.vue'

export default {
  components: { GoodList },
  data() {
    return {
      // 打开类型【0 普通  1 新品（默认） 2 热门】
      openType: 1,
      // 列表开始
      listLoading: true,
      list: [],
      listpage: 1,
      list_rows: 8,
      listtotal: 0,
      listtotalPage: 0,
      // 品牌
      brandList: [
        {
          "brandId": "", //品牌id
          "name": "All", //品牌名称
          "logo": "" //品牌图片
        }
      ],
      activeBrandId: "",
    }
  },
  mounted() {
    this.openType = this.$route.query.openType || 1;
    this.activeBrandId = this.$route.query.bid || "";
    this.getlist();
    this.$get("system/brand/list").then(res => {
      this.brandList.push(...(res.rows || []));
    })
  },
  methods: {
    // 切换品牌
    changeActiveBrand(info) {
      this.activeBrandId = info.brandId;
      this.listpage = 1;
      this.getlist();
    },
    // 分页改变
    listPageChange(page) {
      this.listpage = page;
      this.getlist();
    },
    // 获取列表
    async getlist() {
      try {
        this.listLoading = true;
        var query = {
          pageNum: this.listpage,
          pageSize: this.list_rows,
          type: this.openType,
          brandId: this.activeBrandId,
        }
        var res = await this.$get('system/goods/list', query)
        this.listtotal = res.total;
        this.listtotalPage = Math.ceil(res.total / this.list_rows);
        this.list = res.rows || [];
      } catch (error) {
        console.log(error)
      }
      this.listLoading = false;
    }
  },
}
</script>

<style lang='scss' scoped>
@import './goodList.scss';
</style>
